export function isProgressWithStack(props) {
    return props.stack !== undefined;
}
